<template>
    <div style="padding: 10px;height: 100%;overflow: auto;">
      <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
      <el-form :inline="true" class="demo-form-inline" size="mini">
        <el-form-item label="门店" style="padding-left: 10px;padding-top: 10px;margin-bottom: 5px;" >
            <el-select v-model="storeid" placeholder="门店选择" @change="storeChange">
              <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div v-if="indibas.length==1" style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;margin-bottom: 45px" :key="i" v-for="(item,i) in indibas">
        <div style="text-align: center;font-size: 14px;line-height: 30px">
          {{item.storename}}
        </div>
        <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        <van-row style="text-align: left;line-height: 40px;font-size: 12px">
          <van-col span="24">INDIBA购买人数和余次</van-col>
        </van-row>
        <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
        <div>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">购买人数</van-col>
            <van-col span="8" class="font">用完人数</van-col>
            <van-col span="8" class="font">1-3次人数</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.buycount}}</van-col>
            <van-col span="8" class="fontcolor">{{item.finishcount }}</van-col>
            <van-col span="8" class="fontcolor">{{item.restcount1}}</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">3-10次人数</van-col>
            <van-col span="8" class="font">10以上人数</van-col>
            <van-col span="8" class="font">总余次</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.restcount2}}</van-col>
            <van-col span="8" class="fontcolor">{{item.restcount3}}</van-col>
            <van-col span="8" class="fontcolor">{{item.totalnumber}}</van-col>
          </van-row>
          
          <!--<div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
          <van-row style="text-align: left;line-height: 40px;font-size: 12px">
            <van-col span="24">INDIBA顾客多久未到店</van-col>
          </van-row>
          <div style="border-color: #ebedf0;border-style:solid;color: #969799;border-width:1px;border-bottom: 1px"></div>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">7天未到店</van-col>
            <van-col span="8" class="font">15天未到店</van-col>
            <van-col span="8" class="font">1月未到店</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.day7}}</van-col>
            <van-col span="8" class="fontcolor">{{item.day15}}</van-col>
            <van-col span="8" class="fontcolor">{{item.day30}}</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="font">2月未到店</van-col>
          </van-row>
          <van-row style="text-align: center;line-height: 40px">
            <van-col span="8" class="fontcolor">{{item.day60}}</van-col>
          </van-row>-->
  
          <!--<van-popup v-model="show" closeable position="bottom" :style="{ height: '50%' }">
            <el-table  :data="cardInfoVos" ref="table" style="width: 100%;font-size: 12px;text-align: center" border  height="100%" highlight-current-row>
              <el-table-column prop="cardnumber" width="100" label="会员卡号" align="center"></el-table-column>
              <el-table-column prop="membername" width="100" label="会员姓名" align="center"></el-table-column>
              <el-table-column prop="memberphone" width="100" label="手机号码" align="center"></el-table-column>
            </el-table>
          </van-popup>-->
        </div>
        <el-divider>用完明细</el-divider>
      <el-table  :data="finishData" style="width: 100%;" ref="table" highlight-current-row>
        <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
        <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
      </el-table>
      <el-divider>1-3次明细</el-divider>
      <el-table  :data="rest1Data"  style="width: 100%;" highlight-current-row>
        <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
        <el-table-column prop="membername" label="会员姓名" align="center"></el-table-column>
        <el-table-column prop="isenable"  label="剩余次数" align="center"></el-table-column>
      </el-table>
      <el-divider>3-10次</el-divider>
      <el-table  :data="rest2Data" style="width: 100%;" highlight-current-row>
        <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
        <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
        <el-table-column prop="isenable"  label="剩余次数" align="center"></el-table-column>
      </el-table>
      <el-divider>10次以上</el-divider>
      <el-table  :data="rest3Data"  style="width: 100%;"  highlight-current-row>
        <el-table-column prop="cardnumber"  label="会员卡号" align="center"></el-table-column>
        <el-table-column prop="membername"  label="会员姓名" align="center"></el-table-column>
        <el-table-column prop="isenable"  label="剩余次数" align="center"></el-table-column>
      </el-table>
      </div>
      
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        cardInfoVos:[],
        show:false,
        indibas:[],
        active: 'home',
        height:window.innerHeight-70,
        finishData:[],
        rest1Data:[],
        rest2Data:[],
        rest3Data:[],
        brands:[],
        storeid:localStorage.getItem("storeid")
      };
    },
    created() {
      this.storeid=this.$route.query.storeid;
      this.getStoreInfoByStructsOpen();
      this.getIndibaInfo();
      /*let  userId= this.getUrlKey("userId");
      let code=this.getUrlKey("code");
      if (userId || code) {
        if(userId) {
          this.getCorpUserInfo(userId);
        }
      }
      else{
        window.location.href=this.getBaseUrl()+"/wechatback/getThirdCorpidCode?state=3";
      }*/
      //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjE3Njc3NTYxLCJleHAiOjE2MTc3NjM5NjF9.SQ_6O9vj2_Px4PEzYJ3QKp1MHsDme70PA02SM_l9ACs");
      //localStorage.setItem("storeid","17cc68147ccf470e884f4133312337da");
      //this.getIndibaInfo();
    },
    updated() {
    
    },
    methods:{
      storeChange(val){
        localStorage.setItem("storeid",val);
        this.storeid=val;
        this.getIndibaInfo();
      },
      getStoreInfoByStructsOpen(){
        let parentstoreid=localStorage.getItem("parentstoreid");
        let staffid=localStorage.getItem("staffid");
        this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
          if(res.sucess){
              this.brands=res.object;
          }
          else{
              this.$message({
                message: res.message,
                type: 'error'
              });
          }
        });
      },
      getBuyCourseByRestNumberMemberInfo(storeid,fromnumber,tonumber,type){
        this.$post("cardmobilereoprt/getBuyCourseByRestNumberMemberInfo",{storeid:storeid,fromnumber:fromnumber,tonumber:tonumber}).then((res)=>{
          if(res.sucess){
            //this.show=true;
            //this.cardInfoVos=res.object;
            if(type==1){
              this.finishData=res.object;
            }
            else if(type==2){
              this.rest1Data=res.object;
            }
            else if(type==3){
              this.rest2Data=res.object;
            }
            else if(type==4){
              this.rest3Data=res.object;
            }
          }
          else{
            this.$dialog.alert({
              title:"提示",
              message:res.message
            });
          }
        });
      },
      getCorpUserInfo(staffid){
        let toast=this.$toast.loading({
          mask: true,
          message: '加载中...',
          duration:0
        });
        this.postAxios("/wechat/getCorpUserInfo",{staffid:staffid}).then((res)=>{
          toast.clear();
          if(res.sucess) {
            let data = res.object;
            if (data.staff == null || data.staff == undefined) {
              //如果钉钉没找到就关闭页面
              this.$dialog.alert({
                title: "提示",
                message: "没有找到您的信息"
              }).then(() => {
                window.WeixinJSBridge.call('closeWindow');
              });
              return;
            }
            else {
              this.staff = data.staff;
              localStorage.setItem("token", data.token);
              localStorage.setItem("staffid", data.staff.staffid);
              localStorage.setItem("storeid", data.staff.storeid);
              localStorage.setItem("deptid", data.staff.deptid);
              localStorage.setItem("staffname", data.staff.staffname);
              localStorage.setItem("posid", data.staff.posid);
              this.getIndibaInfo();
            }
          }
          else{
            this.$dialog.alert({
              title:"提示",
              message:res.message
            }).then(()=>{
              window.WeixinJSBridge.call('closeWindow');
            });
          }
        });
      },
      getIndibaInfo(){
        this.$post("cardmobilereoprt/getIndibaInfo",{storeid:this.storeid}).then((res)=>{
          if(res.sucess){
            if(res.object!=null && res.object.length>1){
                this.indibas=[];
            }
            else{
                this.indibas=res.object;
                this.getBuyCourseByRestNumberMemberInfo(this.storeid,0,1,1);
               this.getBuyCourseByRestNumberMemberInfo(this.storeid,1,3,2);
               this.getBuyCourseByRestNumberMemberInfo(this.storeid,3,10,3);
               this.getBuyCourseByRestNumberMemberInfo(this.storeid,10,100000,4);
            }
          }
          else{
            this.$dialog.alert({
              title:"提示",
              message:res.message
            });
          }
        });
      }
    }
  };
  </script>
  <style>
    .font{
      font-size: 14px;
    }
    .fontcolor{
      font-size: 14px;
      color: #1989fa;
    }
    body,html {margin:0; height:100%;}
  </style>


// WEBPACK FOOTER //
// src/page/beauty/indibabuydetal.vue